Wee.routes.map({
	'$root': 'todo'
});